import { wplToken } from '@atlassiansox/wpl-token';
import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';
import { css } from '@emotion/react';

export const containerStyle = css`
  display: block;

  a,
  p,
  h1,
  h2,
  h3,
  button {
    font-weight: 500;
  }

  ${getMediaDown('md')} {
    position: relative;
  }
`;

export const innerContainerStyle = (maxWidth: string) => css`
  margin: 0 auto;
  max-width: ${maxWidth};
`;

export const stepDisplayStyle = css`
  font-size: ${wplToken('space.150')};
  color: ${getColor('n90')};
  margin: 0;
  padding: 0;
`;

export const productSelectionHeaderStyle = css`
  font-size: ${wplToken('space.300')};
  color: ${getColor('n800')};
  margin: 0 0 ${wplToken('space.300')};
  padding: 0;
`;

export const calcLayoutStyles = css`
  display: grid;
  grid-template-columns: 1fr 370px;
  gap: 32px;

  ${getMediaDown('md')} {
    display: block;
  }
`;
